module.exports = __webpack_public_path__ + "img/error.879dff96.svg";